<template>

    <!-- NOM ETABLISSEMENT -->
    <div class="conteneurNomEtablissement">
      <div v-if="nomEtablissementAffiche" class="labelNomEtablissement">
          {{ nomEtablissementAffiche }} 
        </div>
    </div>

    <!-- NOM RESIDENT ET FAMILLE -->
    <div v-if="nomResident != '' && nomFamille != ''" class="conteneurNomResidentEtFamille">
      <div  class="labelNomFamille">{{ nomFamille  }}</div>

      <div class="image-block"><img :src="require('@/assets/telephone.png')" alt="LogoAppel" class="full-height-image"/></div>
        
      <div  class="labelNomResident">{{ nomResident }}</div>
    </div>

    <!-- DATE ET BOUTON SEMAINE -->
    <div v-if="texteDatesSemaines != ''" class="conteneurDatesSemaine">
      <img :src="require('@/assets/fleche.png')" alt="flechePrecedant" class="conteneurBoutonSemainePrecedante" @click="clicVoirSemainePrecedante" />

      <div  class="labelDateSemaine">{{ texteDatesSemaines }}</div>

      <img :src="require('@/assets/fleche.png')" alt="flecheSuivant" class="conteneurBoutonSemaineSuivante" @click="clicVoirSemaineSuivante" />
    </div>

    <!-- PLANNING 7 JOURS -->
    <div v-if="DataCommune.SemaineAffichee != '' && DataCommune.messageDansPlanning == '' && DataCommune.listResaSemaineActuellementAffiche != null" class="blocPlanning">
      <div 
        class="jourPlanning" 
        v-for="index in 7" 
        :key="index"
      >
        <AfficheurJourPlanning :pointerJour="index" />
      </div>
    </div>
    <div v-else class="blocMessageDansPlanning">
      {{ DataCommune.messageDansPlanning }}
    </div>

  <!-- POPUP -->
   <AfficheurPopup/>

  <!-- si on a une erreur => on l'affiche en plein ecran avec bouton recharger la page -->
   <div v-if="messageErreur" class="ensembleMessageErreur">
    <div class="texteMessageErreur">
      {{ messageErreur }} 
    </div>

    <button @click="clicRechargerLaPage()" class="boutonRechargerLaPage">Recharger la page</button>
  </div>

</template>

<script lang="ts">
import { defineComponent   } from 'vue';
import AfficheurJourPlanning from './objetsAafficher/AfficheurJourPlanning.vue'
import { lectureJsonVsIdEtablissement, majPlanningSemaineAffiche } from './fonction/fonctionServeur';
import { recupIdSemaineEnCours, recupDateVsIdSemaineEtIdJour } from './fonction/fonctionDate';
import { ConstServeur, initServeur } from './objetsTypeScript/InfoServeur';
import { DataCommune } from '@/objetsTypeScript/InfoGeneral';
import AfficheurPopup from './objetsAafficher/AfficheurPopup.vue'; 
import { Session} from './objetsTypeScript/Session';



export default defineComponent ({
props:[],
components: {
  AfficheurJourPlanning, 
  AfficheurPopup
},
data() {
    return {
      chargementEtablissementEnCours : true,
      accesClient : false,
      DataCommune,
      messageErreur: '' as string, 
      //messageDansPlanning: '' as string, 
      nomEtablissementAffiche: '', 
      nomResident: '', 
      nomFamille: '', 
      texteDatesSemaines: '', 
      chargementQuestionSuivanteEnCours : false,
      latitude: 0,
      longitude: 0, 
      sessionActuelle : null as Session | null
    }
  },
  
methods:{
    afficherSemaineVsIdSemaine() {
      // on reset la semaine actuelle affichee
      DataCommune.SemaineAffichee = '';
      DataCommune.messageDansPlanning = "";

      // date de debut et de fin de la semaine
      this.texteDatesSemaines = " entre " + recupDateVsIdSemaineEtIdJour(DataCommune.IdSemaineAffichee, 0).recupDateTexte() + " et " + recupDateVsIdSemaineEtIdJour(DataCommune.IdSemaineAffichee, 6).recupDateTexte();
    
      // nom de l'etablissement affichee
      this.nomEtablissementAffiche = DataCommune.CompteEtablissement.nom;

      // si la semaine en cours a ete activee par l'etablissement
      if(DataCommune.CompteEtablissement.listSemainesActivees.includes(DataCommune.IdSemaineAffichee)) {
        // on charge le planning semaine
        majPlanningSemaineAffiche();
      }
      else{
        // message erreur
        DataCommune.messageDansPlanning = "Cette semaine n'a pas encore été communiquée par la résidence...";

      }
},
    clicVoirSemaineSuivante() {
      console.log("clic semaine suivante !");
      // on pointe sur la semaine suivante
      DataCommune.IdSemaineAffichee = DataCommune.IdSemaineAffichee + 1;
      // on affiche la semaine
      this.afficherSemaineVsIdSemaine();
    },
    clicVoirSemainePrecedante() {
      console.log("clic semaine precedante !");
      // on pointe sur la semaine precedante
      DataCommune.IdSemaineAffichee = DataCommune.IdSemaineAffichee - 1;
      // on affiche la semaine
      this.afficherSemaineVsIdSemaine();
    },
    clicRechargerLaPage() {
        window.location.reload();
    }
},
// sur la creation de la page
created() {
  this.chargementEtablissementEnCours = true;
  // on initialise le serveur avec les bons liens
  initServeur(ConstServeur.SERVEUR_WIVYF); 
  
  // on check l'etablissement a partir de l'url
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const idEtablissementSurUrl = urlParams.get('e'); //?e=20888
  const idFamilleSurUrl = urlParams.get('f'); //?f=XXX

  if(idEtablissementSurUrl != null && idFamilleSurUrl != null)
  {
    DataCommune.IdEtablissement = parseInt(idEtablissementSurUrl, 10); // Convert string to integer
    DataCommune.IdFamille = parseInt(idFamilleSurUrl, 10); // Convert string to integer

    // si l'id de l'etablissement est null
    if (isNaN(DataCommune.IdEtablissement)) {
      this.messageErreur = "Impossible de recuperer l'id de l'établissement. Assurez vous d'avoir le bon lien.";
    }
    // si l'id de la famille est null
    else if(isNaN(DataCommune.IdFamille)){
      this.messageErreur = "Impossible de recuperer l'id de votre famille. Assurez vous d'avoir le bon lien.";
    }
    else{
      
      // on va chercher le compte visio de l'etablissement
      lectureJsonVsIdEtablissement(ConstServeur.NOM_TABLE_COMPTE_ETABLISSEMENT, DataCommune.IdEtablissement).then(data => {
        // si on a reussi a recuperer le compte etablissement
        if(data != '') {
          // on recupere l'objet compte eztablissement
          DataCommune.CompteEtablissement = JSON.parse(data);
          // on recupere l'id de la semaine en cours
          DataCommune.IdSemaineAffichee = recupIdSemaineEnCours();
          

          // recuperation de la famille dans le compte etablissement
          DataCommune.Famille = '';
          this.nomFamille = '';
          DataCommune.Resident = '';
          this.nomResident = '';
          if(DataCommune.IdFamille != 1){
            for(let r = 0; r < DataCommune.CompteEtablissement.listeResidents.length; r++){
              //console.log("Resident : "+ JSON.stringify(this.localCompteEtablissement.listeResidents[r]));
              for(let f = 0; f < DataCommune.CompteEtablissement.listeResidents[r].listeFamille.length; f++){
                //console.log("Famille : "+JSON.stringify(this.localCompteEtablissement.listeResidents[r].listeFamille[f]));
                if(DataCommune.CompteEtablissement.listeResidents[r].listeFamille[f].idFamille == DataCommune.IdFamille.toString()){
                  DataCommune.Resident = DataCommune.CompteEtablissement.listeResidents[r];
                  DataCommune.Famille = DataCommune.CompteEtablissement.listeResidents[r].listeFamille[f];
                  this.nomResident  = DataCommune.CompteEtablissement.listeResidents[r].prenom + " " + DataCommune.CompteEtablissement.listeResidents[r].nom;
                  this.nomFamille = DataCommune.CompteEtablissement.listeResidents[r].listeFamille[f].nomPrenom;
                }
              }
            }
          }

          // si on n'a pas reussi a recuperer la famille
          if(DataCommune.Famille == ''){
            this.messageErreur = "Impossible de recuperer la famille. Assurez vous d'avoir le bon lien.";
          }
          // si on a reussi a recuperer la famille
          else{
            // on affiche la semaine en cours avec l'id etablissement
            this.afficherSemaineVsIdSemaine();
          }
          
        }
        // si on n'a pas reussi a recuperer l'etablissement
        else{
          // message erreur
          this.messageErreur = "Impossible de charger l'établissement "+DataCommune.IdEtablissement.toString()+". Essayez de recharger la page.";
        }
      });
    }
  }
  else {
    this.messageErreur = "Impossible de recuperer l'id de l'établissement et/ou de la famille. Assurez vous d'avoir le bon lien.";
  }

  this.chargementEtablissementEnCours = false;

}

});

</script>

<style>
@font-face {
  font-family: 'QuicksandBold';
  src: url('../public/fonts/Quicksand_Bold.otf') format('opentype');
}

@font-face {
  font-family: 'QuicksandBook';
  src: url('../public/fonts/Quicksand_Book.otf') format('opentype');
}

html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  background-color: #6077BA;
  color: white;
}

/* Conteneur principal qui occupe la page entière */
.app-container {
  position: relative;
  width: 100%;
  height: 100vh; /* 100% de la hauteur visible */
  overflow: hidden; /* Empêche le dépassement */  
}

/**********************************************
************** NOM ETABLISSEMENT **************
**********************************************/

.conteneurNomEtablissement {
  font-family: 'QuicksandBook';
    /* Occupe 100% de la largeur et 5% de la hauteur de l'écran */
    margin-left: 0%;
    width: 100%;
    height: 4%; /* ou 5% si tu préfères, mais 5vh est souvent plus fiable */
    
    /* Afin de placer correctement nos éléments sur la même ligne */
    display: flex;
    align-items: center;
    justify-content: center; /* pour centrer horizontalement */

    position: fixed;
    top: 0;
    left: 0;

  }

  .labelNomEtablissement {
    width: 80%;
    text-align: center; /* Centre horizontalement le texte */
    font-size: clamp(5px, 1.2vw, 24px);
  }

/****************************************************
************** NOM RESIDENT ET FAMILLE **************
****************************************************/


.conteneurNomResidentEtFamille {
    font-family: 'QuicksandBold';

    margin-left: 10%;
    width: 80%;
    height: 4%; 

    display: flex;
    align-items: center;  /* pour centrer verticalement */
    justify-content: center; /* pour centrer horizontalement */

    position: fixed;
    top: 4%;
    left: 0;
  }

  .labelNomFamille {
    margin-right: 2%;
    margin-left: 2%;
    width: 40%;
    text-align: right; /* Centre horizontalement le texte */
    font-size: clamp(5px, 1.3vw, 24px);
  }

  .labelNomResident {
    margin-right: 2%;
    margin-left: 2%;
    width: 40%;
    text-align: left; /* Centre horizontalement le texte */
    font-size: clamp(5px, 1.3vw, 24px);
}

  .image-block {
    width: auto;
    height: 100%;
  }

/* L'image prend 100% de la largeur et de la hauteur de son bloc */
.full-height-image {
  width: 100%;
  height: 100%;
  object-fit: cover; /* L'image sera recadrée pour remplir l'espace sans se déformer */
  display: block;    /* Pour éviter un espace blanc sous l'image en inline-block */
}


  /*******************************************************
  ************** DATES SEMAINE AVEC BOUTONS **************
  *******************************************************/

  .conteneurDatesSemaine {
    font-family: 'QuicksandBook';
    /* Occupe 100% de la largeur et 5% de la hauteur de l'écran */
    margin-left: 10%;
    width: 80%;
    height: 4%; 

    display: flex;
    align-items: center;  /* pour centrer verticalement */
    justify-content: center; /* pour centrer horizontalement */

    position: fixed;
    top: 9%;
    left: 0;
  }

  .labelDateSemaine {
    width: 40%;
    text-align: center; /* Centre horizontalement le texte */
    font-size: clamp(5px, 1.8vw, 24px);
  }

  .conteneurBoutonSemainePrecedante {
    width: auto;
    height: 100%;
  }

  .conteneurBoutonSemaineSuivante {
    width: auto;
    height: 100%;
    transform: scaleX(-1); /* Inversion horizontale */
  }


  /*******************************************************
  ******************** BLOC PLANNING *********************
  *******************************************************/

.blocPlanning {
  font-family: 'QuicksandBold';
  position: absolute;
  top: 12%;             /* Démarre juste après le header */
  left: 0;
  width: 100%;
  height: 88%;         /* 90% de la hauteur de la page */
  
  /* On inclut les “marges” latérales dans cette zone,
     grâce à un padding horizontal */
  padding: 1% 1%;
  box-sizing: border-box;
  
  /* Disposition en grille sur 7 colonnes */
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0.8vw;             /* Espace de 5 px entre chaque élément */
}

.blocMessageDansPlanning {
  font-family: 'QuicksandBold';
  position: absolute;
  top: 12%;             /* Démarre juste après le header */
  left: 5%;
  width: 90%;
  height: 88%;         /* 90% de la hauteur de la page */
  
  /* On inclut les “marges” latérales dans cette zone,
     grâce à un padding horizontal */
  padding: 1% 1%;
  box-sizing: border-box;

  white-space: pre-line;

  font-size: clamp(5px, 2vw, 50px);

  /* centre le texte horizontallement */
  text-align: center;
  /* centre le texte verticalement */
  display: flex;
  align-items: center;
  justify-content: center;
}

.jourPlanning {
  background-color: #BFC9E4; /* Exemple de couleur de fond */
  height: 100%;
  border-radius: 20px;
}

/*************************************
****** AFFICHAGE MESSAGE ERREUR ******
**************************************/
.ensembleMessageErreur {
box-sizing: border-box;
  width: 100%;  /* 100% of the viewport width */
  height: 100%;  /* 50% of the viewport height */
  padding: 10%;
  position: fixed;
  /* met le bloc a la suite du bloc precedant */
  float : left; 
  bottom: 0;
  left: 0;
  margin: 0;
  /* typo quicksand bold */
  font-family: 'QuicksandBold';
  /* fond bleu */
  background-color: #2F3E53; /* Color of the rectangle */
}

.texteMessageErreur {
  box-sizing: border-box;
  width: 100%;  /* 100% of the viewport width */
  height: 70%;  /* 50% of the viewport height */
  padding: 10%;
  position: relative;
  /* met le bloc a la suite du bloc precedant */
  float : left; 
  /* texte blanc */
  color: white;
  /* fond bleu */
  background-color: #2F3E53; /* Color of the rectangle */
  /* centre le texte horizontallement */
  text-align: center;
  /* centre le texte verticalement */
  display: flex;
  align-items: center;
  justify-content: center;
}

.boutonRechargerLaPage {
  box-sizing: border-box;
  width: 50%;  /* 100% of the viewport width */
  height: 30%;  /* 50% of the viewport height */
  min-width: 250px; 
  padding: 0;
  /* met le bloc a la suite du bloc precedant */
  bottom: 0;
  left: 0;
  margin: 0 auto;
  margin-top: 5%;
  /* typo quicksand bold */
  font-family: 'QuicksandBold';
  /* texte blanc */
  color: #2F3E53;
  /* fond bleu */
  background-color: white; /* Color of the rectangle */
  /* bord arrondi */
  border-radius: 25px;
  /* centre le texte horizontallement */
  text-align: center;
  /* centre le texte verticalement */
  display: flex;
  align-items: center;
  justify-content: center;

}



</style>
